// lib/adminFuzzySearch.js
// Fuzzy search over ADMIN_NAV_ITEMS for the Command Palette.
// Uses fuse.js with weighted keys; empty/whitespace query returns [].
// Teaching source: config/adminNav.js — ADMIN_NAV_ITEMS with keywords[]

import Fuse from 'fuse.js'
import { ADMIN_NAV_ITEMS } from '@/config/adminNav'

// Build a fresh Fuse instance on first call and reuse it.
// Items with href: null (e.g. 'more' placeholder) are excluded from search.
const SEARCHABLE = ADMIN_NAV_ITEMS.filter(item => item.href != null)

const fuse = new Fuse(SEARCHABLE, {
  keys: [
    { name: 'label',    weight: 2 },
    { name: 'keywords', weight: 1.5 },
    { name: 'id',       weight: 0.5 },
  ],
  threshold: 0.4,
  minMatchCharLength: 2,
  includeScore: false,
})

/**
 * Search ADMIN_NAV_ITEMS by fuzzy match.
 * @param {string} query — raw user input
 * @returns {import('@/config/adminNav').NavItem[]} — matched items (no duplicates)
 */
export function searchNavItems(query) {
  if (!query || !query.trim()) return []
  if (query.trim().length < 2) return []
  const results = fuse.search(query.trim())
  return results.map(r => r.item)
}
